import styled from 'styled-components';

export const IconBackLight = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 4px;
`;
